import { GetCustomersById, GetCustomersByIdToken } from "$src/application/customers/queries/GetCustomerById";
import { Customer } from "$src/domain/customers/Customer";
import { useQuery } from "@sveltestack/svelte-query";
import { container } from "tsyringe";


export async function fetchCustomer(groupStoreId: number, customerId: number): Promise<Customer> {
    const query = container.resolve<GetCustomersById>(GetCustomersByIdToken);
    return query.execute(groupStoreId, customerId.toString());
}

export function useCustomer(groupStoreId: number, customerId: number) {
    return useQuery<Customer, Error>({
        queryKey: ['customer', customerId],
        queryFn: () => fetchCustomer(groupStoreId, customerId),
        staleTime: 30000,
        cacheTime: 60000,
    });
}